import { render } from "./AgentRequestsTable.vue?vue&type=template&id=c8712004"
import script from "./AgentRequestsTable.vue?vue&type=script&lang=js"
export * from "./AgentRequestsTable.vue?vue&type=script&lang=js"

import "./AgentRequestsTable.vue?vue&type=style&index=0&id=c8712004&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__